import { defaultConfig, defineSlotRecipe } from '@chakra-ui/react';

import merge from 'lodash/merge';

export const listSlotRecipe = defineSlotRecipe(
    merge(defaultConfig?.theme?.slotRecipes?.list, {
        variants: {
            variant: {
                marker: {
                    root: {
                        listStyle: 'disc',
                    },
                    item: {
                        _marker: {
                            color: 'inherit',
                        },
                    },
                },

                separated: {
                    root: {
                        display: 'flex',
                        listStyle: 'none',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        gap: 2,
                    },
                    item: {
                        _after: {
                            content: '"\u2022"',
                            mt: '-1px',
                            ml: 2,
                            color: 'var(--list-marker-color)',
                            transform: 'scale(1.25)',
                        },
                        '&:last-child': {
                            _after: {
                                display: 'none',
                            },
                        },
                    },
                },
            },
        },
    }),
);
